import {
  Component,
  ElementRef,
  EventEmitter,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import * as dayjs from "dayjs";
import { BlackListService } from "../blacklist.service";
import { NgxImageCompressService } from "ngx-image-compress";
import dataURItoBlob from "src/app/utils/dataURItoBlob";
import { CURP_REGEX } from "src/app/utils/constants";

@Component({
  selector: "app-form-blacklist",
  templateUrl: "./form.component.html",
})
export class BlackListForm implements OnInit {
  public imgDef =
    "https://us.123rf.com/450wm/tvectoricons/tvectoricons1811/tvectoricons181105271/112229760-add-photos-icon-trendy-flat-vector-add-photos-icon-on-white-background-from-general-collection.jpg?ver=6";

  public curpRegex = CURP_REGEX;
  public form: FormGroup;
  public mode: "stanby" | "create" | "update" = "stanby";
  public defaults?: any = undefined;
  @ViewChild("imageInput", { static: false }) public imageInput: ElementRef;
  public valueImg = "";
  public imgFile: File = undefined;

  @Output() onsave = new EventEmitter<{
    mode: string;
    value: any;
    file: File;
  }>();

  constructor(
    private fb: FormBuilder,
    public service: BlackListService,
    private imageCompress: NgxImageCompressService
  ) {}

  public ngOnInit() {
    this.buildForm();
  }
  public setStanby() {
    this.mode = "stanby";
    this.defaults = undefined;
    this.form.reset();
  }
  public setCreate() {
    this.mode = "create";
    this.defaults = undefined;
    this.form.reset();
  }

  public setUpdate(row: any) {
    this.mode = "update";
    this.defaults = row;
    this.form.controls["IdBlackList"].setValue(this.defaults?.IdBlackList);
    this.form.controls["Nombre"].patchValue(this.defaults?.Nombre);
    this.form.controls["Razon"].patchValue(this.defaults?.Razon);
    this.form.controls["CURP"].patchValue(this.defaults?.CURP);
    this.loadImage();
  }

  public save() {
    if (this.mode === "create") this.create();
    else if (this.mode === "update") this.update();
  }

  public create() {
    this.onsave.emit({
      mode: this.mode,
      value: this.form.value,
      file: this.imgFile,
    });
  }

  public update() {
    this.onsave.emit({
      mode: this.mode,
      value: this.form.value,
      file: this.imgFile,
    });
  }

  public isCreateMode() {
    return this.mode === "create";
  }

  public isUpdateMode() {
    return this.mode === "update";
  }

  // TODO add validators
  private buildForm() {
    this.form = this.fb.group({
      IdBlackList: [""],
      Nombre: ["", [Validators.required]],
      Razon: [""],
      CURP: ["", [Validators.required, Validators.pattern(this.curpRegex)]],
    });
  }
  public loadImage() {
    this.service.image(this.defaults.IdBlackList).subscribe(
      (str) => (this.valueImg = str),
      (err) => (this.valueImg = this.imgDef)
    );
  }
  public getImgFile() {
    this.imageCompress.uploadFile().then(({ image, orientation }) => {
      this.imageCompress
        .compressFile(image, orientation, 50, 50) // 50% ratio, 50% quality
        .then((compressedImage) => {
          const blob = dataURItoBlob(compressedImage);
          this.valueImg = compressedImage;
          this.imgFile = new File(
            [blob],
            "Imagen" + new Date().getTime().toString(16)
          );
        });
    });
  }
  errorHandler(event) {
    event.target.src = this.imgDef;
  }
}
